import { ListItemAvatar } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledListItemAvatar = styled(ListItemAvatar)(() => ({
  minWidth: '40px',
})) as typeof ListItemAvatar;

export default StyledListItemAvatar;
